import { Button } from '@jouzen/ecom-components/v3/Button';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';

import { EventType } from '@/analytics/types';
import Motion from '@/app/components/Motion';
import SectionHeading from '@/app/components/SectionHeading';
import { STORE_POP_PATHNAME } from '@/app/consts/pathnames';

const PopFinishesContent = () => {
  const t = useTranslations();
  const path = usePathname();

  const handleCtaClick = () => {
    void window.ouraAnalytics.track(EventType.CTAClicked, {
      cta: 'choose your oura ring 4',
      action: 'go_to_wizard',
      location: 'body',
      path,
    });
  };

  return (
    <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between lg:gap-12">
      <SectionHeading
        animated
        className="md:max-w-[590px]"
        content="pop_gen4_finishes_title"
        typographyProps={{
          className: 'leading-tighter text-current font-normal',
          Element: 'h2',
          variant: 'h3',
        }}
      />
      <Motion
        initial={{ opacity: 0 }}
        transition={{ delay: 0.25, duration: 0.75, type: 'tween' }}
        viewport={{ once: true }}
        whileInView={{ opacity: 1 }}
      >
        <Button
          className="whitespace-nowrap"
          href={`${STORE_POP_PATHNAME}/oura-ring-4/silver`}
          onClick={handleCtaClick}
          size="large"
          variant="secondary-dark"
        >
          {t('choose_your_oura_ring')}
        </Button>
      </Motion>
    </div>
  );
};

export default PopFinishesContent;
